import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
const columns = [{
  slots: {
    title: '文件名称'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center'
}, {
  slots: {
    title: '条款文件'
  },
  dataIndex: 'linkName',
  key: 'linkName',
  align: 'center',
  scopedSlots: {
    customRender: 'linkName'
  }
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'operation',
  key: 'operation',
  align: 'center',
  width: 160,
  scopedSlots: {
    customRender: 'operation'
  }
}];
import topTitle from '@/components/title';
import { quillEditor } from 'vue-quill-editor';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import termsModel from '../components/termsModel.vue';
import { healthEdit, mainDetailV2, addInsuranceTerms, insuranceTermsEdit, insuranceTermsResource } from './../request';
import quillConfig from '@/views/components/editor/quill-config.js';
import { uploadFile } from '@/views/customer/applicationManage/request';
import { cryptoDecrypt } from '@/utils/aes';
export default {
  props: ['id', 'info'],
  components: {
    topTitle,
    quillEditor,
    termsModel
  },
  data() {
    return {
      action: uploadFile,
      columns,
      healthNotice: '',
      quillOption: quillConfig,
      current: 0,
      checked: false,
      form: {
        id: undefined,
        link: '',
        linkName: '',
        content: '',
        name: ''
      },
      tableData: [],
      fileList: [],
      termsConfig: '',
      delArr: [],
      termsShow: false,
      disabled: true,
      saveLoading: false,
      saveTermLoading: false,
      uploadStatus: false,
      uploadStatus2: false
    };
  },
  computed: {
    rules() {
      return {
        name: [{
          required: true,
          validator: this.validateName,
          trigger: 'blur'
        }],
        // file: [{required: true, message: '请上传条款文件', trigger: 'change'}],
        link: [{
          required: true,
          message: this.$t('请上传') + this.$t('条款文件'),
          trigger: 'change'
        }],
        content: [{
          required: true,
          message: this.$t('请输入') + this.$t('文本内容'),
          trigger: 'blur'
        }]
      };
    }
  },
  mounted() {
    var _this$$refs$myTextEdi;
    (_this$$refs$myTextEdi = this.$refs.myTextEditor) === null || _this$$refs$myTextEdi === void 0 || _this$$refs$myTextEdi.quill.enable(false);
    setTimeout(() => {
      var _this$$refs$myTextEdi2;
      (_this$$refs$myTextEdi2 = this.$refs.myTextEditor) === null || _this$$refs$myTextEdi2 === void 0 || _this$$refs$myTextEdi2.quill.enable(true);
    }, 1000);
    this.getTermsList();
  },
  // mounted() {
  //   // this.healthNotice = this.info.healthNotice || '';
  //   // this.checked = !this.info.isFile ? true : false;
  //   this.getTermsList();
  // },
  methods: {
    validateName(rule, value, callback) {
      if (!this.form.name) {
        callback(new Error(this.$t('请输入') + this.$t('文件名称')));
      } else {
        if (this.form.name.length > 50) {
          callback(new Error(this.$t('最多输入') + '50' + this.$t('字符')));
        } else if (this.form.name.length < 4) {
          callback(new Error(this.$t('至少输入') + '4' + this.$t('字符')));
        }
        callback();
      }
    },
    async saveTermsList() {
      if (this.uploadStatus2) {
        return this.$message.error(this.$t('文件上传中,禁止点击操作'));
      }
      this.saveLoading = true;
      let obj = {};
      if (this.tableData.length != 0 && !this.checked) {
        const arr = this.tableData.map(item => {
          return item.id;
        });
        obj.insuranceId = this.id;
        obj.isFile = this.checked ? 0 : 1;
        obj.insuranceTermsId = arr.join(',');
        obj.deleteInsuranceTermsId = this.delArr;
        obj.termsList = this.tableData;
      } else {
        obj.insuranceId = this.id;
        obj.isFile = this.checked ? 0 : 1;
        obj.insuranceTermsId = '';
        obj.deleteInsuranceTermsId = [];
        obj.termsList = [];
      }
      await insuranceTermsEdit(obj);
      this.$message.success(this.$t('操作成功'));
      setTimeout(() => {
        this.saveLoading = false;
      }, 500);
    },
    async getTermsList() {
      const res = await mainDetailV2({
        insuranceId: this.id
      });
      this.tableData = res.termsList;
      this.termsConfig = res.termsConfig;
      this.healthNotice = res.healthNotice;
      this.checked = res.isFile === 0 ? true : false;
      if (this.checked || this.tableData.length) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    tabFun(num) {
      if (this.uploadStatus2) {
        return this.$message.error(this.$t('文件上传中,禁止点击操作'));
      }
      this.current = num;
    },
    async nextFun() {
      await this.saveTermsList();
      await healthEdit({
        insuranceId: this.id,
        healthNotice: this.healthNotice
      });
      // this.$emit('next', res);
      this.$emit('next');
    },
    prevFun() {
      this.$emit('prev');
    },
    handleChange({
      file,
      fileList
    }) {
      const isThanMax = file.size / 1024 / 1024 < 10;
      console.log(file.size / 1024 / 1024);
      if (!isThanMax) {
        return this.$message.error(this.$t('文件过大，请选择10M以下文件上传'));
      }
      if (file.type !== 'application/pdf') {
        return this.$message.error(this.$t('仅支持上传PDF格式文件'));
      }
      this.uploadStatus = true;
      this.uploadStatus2 = true;
      fileList = fileList.map(file => {
        if (file.response) {
          file.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
        }
        return file;
      });
      const fileArr = fileList.length != 0 ? [fileList[fileList.length - 1]] : [];
      this.fileList = fileArr;
      if (fileArr.length != 0 && fileArr[0].url) {
        this.form.linkName = fileArr.length != 0 ? fileArr[0].name : '';
        this.form.link = fileArr.length != 0 ? fileArr[0].url : '';
      }
      if (file.status === 'done') {
        this.$message.success(`${file.name} ` + this.$t('上传成功'));
        this.uploadStatus = false;
        this.uploadStatus2 = false;
      } else if (file.status === 'error') {
        this.$message.error(`${file.name} ` + this.$t('上传失败'));
        this.uploadStatus = false;
        this.uploadStatus2 = false;
      }
    },
    async saveList() {
      if (!this.checked) {
        if (this.uploadStatus) {
          return this.$message.error(this.$t('文件上传中,等待上传完成再添加'));
        }
        this.$refs.form.validate(async valid => {
          if (valid) {
            this.saveTermLoading = true;
            const res = await addInsuranceTerms(Object.assign(recursionCopy(this.form), {
              type: 1
            }));
            const res2 = await insuranceTermsResource({
              insuranceTermsId: res.termsId
            });
            this.$message.success(this.$t('添加成功') + '!');
            this.fileList = [];
            const obj = recursionCopy(this.form);
            obj.link = res2[0].link;
            this.tableData.push(Object.assign(obj, {
              insuranceTermsId: res.termsId,
              id: res.termsId
            }));
            if (!this.checked) {
              if (this.tableData.length == 0) {
                this.disabled = true;
              } else {
                this.disabled = false;
              }
            } else {
              this.disabled = false;
            }
            this.$refs['form'].resetFields();
            this.form = {
              name: '',
              linkName: '',
              content: '',
              link: ''
            };
            this.saveTermLoading = false;
          }
        });
      }
    },
    async editList(val, index) {
      this.termsShow = true;
      this.$nextTick(() => {
        this.$refs.termsRef.init(recursionCopy(val), index, 1);
      });
    },
    changeChecked() {
      if (this.uploadStatus2) {
        return this.$message.error(this.$t('文件上传中,禁止点击操作'));
      }
      this.checked = !this.checked;
      this.uploadStatus = this.checked;
      if (this.checked || this.tableData.length) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
      // this.clearForm();
    },
    updateTermsFun(val, index) {
      this.tableData.splice(index, 1, val);
    },
    async delList(id, index) {
      this.delArr.push(id);
      this.tableData.splice(index, 1);
      if (!this.checked) {
        if (this.tableData.length == 0) {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
      } else {
        this.disabled = false;
      }
    },
    onPreview(info) {
      window.open(info.link);
    },
    clearForm() {
      this.form.id = undefined;
      this.form.insuranceTermsId = undefined;
      this.form.name = '';
      this.form.link = '';
      this.form.linkName = '';
      this.form.content = '';
      this.$refs.form.resetFields();
    }
  }
};